import React, { useEffect, useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Card, CardContent, Typography, Tabs, Tab, Box } from '@material-ui/core';
import { FuseAnimate } from '@fuse';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { reg, isTrainingEnabled, brandingInfo } from '@config';
import LoginTab from './LoginTab';
import TrainingSessionTab from './TrainingSessionTab';
import pJSON from '../../../../package.json';
import axios from 'axios';

import { useLocation, useHistory } from 'react-router-dom';

// CONFIGURATION: Set to true for new 2-tab layout (Sign-In | Workshops), false for legacy 3-tab layout (Admin | Instructor | Students)
const USE_TWO_TAB_LAYOUT = true;


const useStyles = makeStyles((theme) => ({
	root: {
		backgroundImage: 'url("assets/images/backgrounds/dark-material-bg.jpg")',
		color: theme.palette.primary.contrastText,
		'background-size': 'cover',
	},
	textbkglogin: {
		backgroundImage: "url('../../assets/images/backgrounds/text-bkg.png')",
		backgroundRepeat: 'repeat-y',
		backgroundSize: 'cover',
		paddingTop: '7rem',
		paddingLeft: '10rem',
		paddingRight: '10rem',
		paddingBottom: '20rem',
	},
	textjustify: {
		textAlign: 'justify',
		textJustify: 'inter-word',
	},
	fixedWidth: {
		maxWidth: '400px',
	},
	centeredContent: {
		textAlign: 'center',
	},
	dividerContainer: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	divider: {
		flexGrow: 1,
	},
	dividerText: {
		margin: theme.spacing(0, 2),
	},
}));

function TabPanel(props) {
	const { children, value, index, ...other } = props;
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

const Login = (props) => {
	const classes = useStyles();
	const location = useLocation();
	const history = useHistory();

	const isTrainingRoute = location.pathname.includes('/' + brandingInfo.training_login_route);
	// For 2-tab layout: index 0 = Sign-In, index 1 = Workshops
	// For 3-tab layout: index 0 = Admin, index 1 = Instructor, index 2 = Students/Workshops
	const defaultTabIndex = isTrainingRoute ? (USE_TWO_TAB_LAYOUT ? 1 : 2) : 0;
	const [value, setValue] = useState(defaultTabIndex);
	const [recoverPassword, setRecoverPassword] = useState(false);
	const [textLogin, setTextLogin] = useState('Loading...');
	const [showTraining, setShowTraining] = useState(false);

	useEffect(() => {
		axios
			.get(brandingInfo.login_html)
			.then(res => setTextLogin(res.data))
			.catch(err => console.error(err));

		const getTraining = async () => {
			const training = await isTrainingEnabled();
			setShowTraining(training);
		};
		getTraining();
	}, []);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		if (isTrainingRoute && newValue === 0) {
			history.push('/login');
		}
	};

	return (
		<div className={clsx(classes.root, 'flex flex-col flex-1 flex-shrink-0 p-24 md:flex-row md:p-0')}>
			<div className="flex flex-col flex-grow-0 items-center text-white p-16 text-center md:p-64 md:items-start md:flex-shrink-0 md:flex-1 md:text-left">
				<FuseAnimate delay={400}>
					<div className={clsx(classes.textjustify, 'max-w-640 ')}>
						<div dangerouslySetInnerHTML={{ __html: textLogin }}></div>
						<Typography variant="subtitle1" color="inherit" className="mt-16">
							Version {pJSON.version}
						</Typography>
					</div>
				</FuseAnimate>
			</div>

			<FuseAnimate animation={{ translateX: [0, '100%'] }}>
				<Card className="mt-64 mb-64 min-w-400 mr-216">
					{!isTrainingRoute && (
						USE_TWO_TAB_LAYOUT ? (
							<Tabs value={value} onChange={handleChange} aria-label="login tabs" variant="fullWidth">
								<Tab label="Sign-In" key="signin" />
								<Tab label="Workshops" key="workshops" />
							</Tabs>
						) : (
							<Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="scrollable" scrollButtons="auto">
								<Tab label="Admin" key="1" className="w-1/3" />
								<Tab label="Instructor" key="2" className="w-1/3" />
								<Tab label={brandingInfo.training_tab} key="3" className="w-1/3" />
							</Tabs>
						)
					)}
					<CardContent className={`flex flex-col items-center justify-center md:pt-64 w-full pl-0 pr-0 `}>
						{USE_TWO_TAB_LAYOUT ? (
							<>
								<TabPanel value={value} index={0}>
									<LoginTab props={props} setRecoverPassword={setRecoverPassword} recoverPassword={recoverPassword} reg={reg} />
								</TabPanel>
								<TabPanel value={value} index={1}>
									<TrainingSessionTab props={props} setRecoverPassword={setRecoverPassword} recoverPassword={recoverPassword} />
								</TabPanel>
							</>
						) : (
							<>
								<TabPanel value={value} index={0}>
									<LoginTab props={props} setRecoverPassword={setRecoverPassword} recoverPassword={recoverPassword} reg={reg} />
								</TabPanel>
								<TabPanel value={value} index={1}>
									<LoginTab props={props} setRecoverPassword={setRecoverPassword} recoverPassword={recoverPassword} reg={reg} />
								</TabPanel>
								<TabPanel value={value} index={2}>
									<TrainingSessionTab props={props} setRecoverPassword={setRecoverPassword} recoverPassword={recoverPassword} />
								</TabPanel>
							</>
						)}
					</CardContent>
				</Card>
			</FuseAnimate>
		</div>
	);
};

export default Login;

